<div class="table-responsive">
  <table class="table table-nowrap mb-0">
    <!-- <colgroup appColEvenly [cols]="6"></colgroup> -->
    <thead>
      <tr>
        <th *ngIf="showAccount">Account</th>
        <th>Time</th>
        <th>Type</th>
        <th class="text-end">Amount</th>
        <th class="text-end">Shares</th>
        <th class="text-end">Price</th>
        <th class="text-end">Fee</th>
        <th class="text-end">Gas Fee</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let record of records ">
        <td *ngIf="showAccount">
          <app-address [address]="record.account" [category]="record.category" [note]="record.note"></app-address>
        </td>
        <td>
          <a [href]="ethWalletService.getTxUrl(record.txHash)" target="_blank" rel="noopener">{{ (record.timestamp * 1000) | date: 'MMM dd, y, HH:mm' }}</a>
        </td>
        <td>
          <span *ngIf="record.type === 'deposit'">Deposit</span>
          <span *ngIf="record.type === 'withdraw'">Withdraw</span>
        </td>
        <td class="text-end">
          <ngx-money
            [class.text-success]="record.amount.gt(0)"
            [class.text-danger]="record.amount.lt(0)"
            [value]="record.amount"
            [precision]="2"
            [signed]="true"
            symbol="$"
          ></ngx-money>
        </td>
        <td class="text-end">
          <ngx-money
            [class.text-success]="record.shares.gt(0)"
            [class.text-danger]="record.shares.lt(0)"
            [value]="record.shares"
            [precision]="2"
            [signed]="true"
          ></ngx-money>
        </td>
        <td class="text-end">
          $<ngx-money [value]="record.price" [precision]="4"></ngx-money>
        </td>
        <td class="text-end">
          $<ngx-money [value]="record.fee.abs()" [precision]="4"></ngx-money>
        </td>
        <td class="text-end">
          $<ngx-money [value]="record.gasFee" [precision]="2"></ngx-money>
        </td>
      </tr>
    </tbody>
  </table>
</div>
